var u = navigator.userAgent
var ua = navigator.userAgent.toLowerCase()
const agent = {
    isIos: /iphone|ipad|ipod/.test(ua),
    isAndroid: (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 ) ? true : false,
    isApp: openInWebview(),
    isWeiXin: ua.match(/MicroMessenger/i) == 'micromessenger' ? true : false,
    isAlipay: ua.match(/Alipay/i) == "alipay" ? true : false,
    isMobile: (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
  }
export default agent;

function openInWebview () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') { // 微信浏览器判断
      return false
  } else if (ua.match(/QQ/i) == 'qq') { // QQ浏览器判断
      return false
  } else if (ua.match(/WeiBo/i) == "weibo") {
      return false
  } else {
      if (ua.match(/Android/i) != null) {
          return ua.match(/browser/i) == null
      } else if (ua.match(/iPhone/i) != null) {
          return ua.match(/safari/i) == null
      } else {
          return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null)
      }
  }
}


// WEBPACK FOOTER //
// ./src/utils/agent.js